// extracted by extract-css-chunks-webpack-plugin
module.exports = {"container":"Location__container___33w1U"};